import { render, staticRenderFns } from "./particles-stars.vue?vue&type=template&id=b7b75e1a&scoped=true"
import script from "./particles-stars.vue?vue&type=script&lang=js"
export * from "./particles-stars.vue?vue&type=script&lang=js"
import style0 from "./particles-stars.vue?vue&type=style&index=0&id=b7b75e1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b75e1a",
  null
  
)

export default component.exports